import { Component, Input } from '@angular/core';
import { NgbActiveModal }   from '@ng-bootstrap/ng-bootstrap';

import { CaptureModalOptionsModel } from './models/modal.capture.options';

@Component({
  selector   : 'wor-capture-modal',
  template: require('./modal.capture.component.html')
})
export class CaptureModalComponent {

  @Input() options : CaptureModalOptionsModel;

  constructor(
    public activeModal: NgbActiveModal
  ) {}
}
